"use strict";

(function () {
  'use strict';

  function verticalNavCtrl($state) {
    this.isActive = function (state) {
      return $state.current.name === state;
    };
  }

  verticalNavCtrl.$inject = ['$state'];
  angular.module('vertical-nav', []).component('verticalNav', {
    bindings: {
      navItems: '<'
    },
    controller: verticalNavCtrl,
    templateUrl: 'components/vertical-nav/vertical-nav.html'
  });
})();